import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { useComponentClassName } from "../../auxiliary/useComponentClassName.js";
import { toEnumClass } from "../../utils/toEnumClass.js";
const LayoutPageContent = memo(({ children, layout, pageContentLayout = "center" }) => {
  const componentClassName = useComponentClassName("layout-page-content");
  if (layout === "full-width" && !pageContentLayout) {
    pageContentLayout = "stretch";
  }
  return /* @__PURE__ */ jsx("div", { className: componentClassName, children: /* @__PURE__ */ jsx("div", { className: classNames(
    `${componentClassName}-container`,
    toEnumClass("layout-", pageContentLayout ?? layout)
  ), children }) });
});
LayoutPageContent.displayName = "LayoutPageContent";
const PageLayoutContent = LayoutPageContent;
export {
  LayoutPageContent,
  PageLayoutContent
};
//# sourceMappingURL=LayoutPageContent.js.map
